<template>
    <div class="content">
        <img :src="upDataImg" alt=""  v-if="isAuth==1 && objInfo.is_wechat==6"/>
        <div class="ecty" v-if="isAuth==0 || objInfo.is_wechat!=6">
            <img class="logo" src="@/assets/images/poster/logo-enty.png" alt="">
            <div class="content">
                <img src="@/assets/images/poster/emty.png" alt="">
                <span>{{objInfo.is_wechat!=6?'请使用企业微信扫码进入':'无喜报详情权限'}} </span>
            </div>
            <img class="project-img" src="@/assets/images/poster/pro-img.jpg" alt="">
        </div>
    </div>
</template>
<script>
import oForm from "@/js/form.js";
import { getWxSingleConfig } from "@/js/wx.js";
import oStorage from '@/libsV2/storage.js';
export default {
    data() {
        return {
            upDataImg: "",
            isAuth:3,
            objInfo:{
                is_wechat:6
            },
        };
    },
    created() {
        this.$store.commit("loadSwitch", true);
        $init(()=>{
            let that =this
            let confit = {
                share_friend_title: "AI-LiNK冷暖风水签单喜报",
                share_friend_desc: "中央空调·采暖·新风·全屋用水",
                share_img_url:
                    "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/xb_icon.jpg",
                share_link: `${window.location.protocol}//${window.location.host}/other/poster/sales`,
            };
            getWxSingleConfig(confit);
            oForm.posterAuth({code:this.$route.query.code}).then(res=>{
                this.isAuth = res.data.data.result.is_pass
                this.objInfo=res.data.data.result
                // 判断是否白名单
                if(this.isAuth ==0 || this.objInfo.is_wechat!=6){
                    this.$store.commit("loadSwitch", false);
                }else{
                    // this.upDataImg=res.data.data.result.img_detail
                    let canvasCom = document.createElement("canvas");
                    let context = canvasCom.getContext("2d");
                    canvasCom.width = 750;
                    canvasCom.height = 1547;
                    context.fillStyle = "#fff";
                    context.fillRect(
                        0,
                        0,
                        canvasCom.width,
                        canvasCom.height
                    );
                    var img = new Image();
                    img.crossOrigin = "anonymous";
                    img.src=res.data.data.result.img_detail
                    img.onload=function (){
                        const myFont2 = new FontFace(
                            "myFont2",
                            "url(/static/方正兰亭准黑.TTF)"
                        );
                        context.drawImage(img, 0, 0);
                        context.font='30px' + ' ' +'"myFont2"'
                        context.fillStyle='#fff'
                        context.globalAlpha = 0.4;
                        context.rotate(360 + ( -120 * Math.PI / 180 ))
                        let str =`${that.objInfo.uname || ''}-${that.objInfo.company|| ''}-${that.objInfo.phone|| ''}`
                        context.fillText(str, 10, 250);
                        context.fillText(str, 100, 500);
                        context.fillText(str, 20, 850);
                        context.fillText(str, 30, 1400);
                        let imgUrl = canvasCom.toDataURL("image/png");
                        that.upDataImg=imgUrl
                        console.log(imgUrl)
                        setTimeout(()=>{
                            that.$store.commit("loadSwitch", false);
                        },300)
                    }
                }
            })
        })
    },
};
</script>
<style lang="scss" scoped>
.ecty{
    width: 100%;
    height: 100vh;
    position: relative;
    .logo{
        width: 219px;
        height: 52px;
        position: absolute;
        top: 52px;
        left: 45px;
    }
    .project-img{
        width: 600px;
        position: absolute;
        bottom: 100px;
        left:50%;
        transform: translateX(-50%);
    }
    .content{
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translate(-50%,-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        img{
            width: 105px;
        }
        span{
            color: #7f7f7f;
            margin-top: 25px;
            font-size: 32px;
        }
    }
}
.content {
    width: 100%;
    min-height: 100vh;
    img {
        width: 100%;
    }
}
</style>
